import React, { useCallback, useEffect } from "react";
import { Typography } from "antd";
import { useFetchApi } from "../../../../../../hooks/useFetchApi";
import { ChartCard } from "../components/ChartCard";

const { Title } = Typography;

interface AnnualHistoryProps {
  selectedStock?: any;
  baseCurrency: string;
}

export const AnnualHistory: React.FC<AnnualHistoryProps> = ({
  selectedStock,
  baseCurrency,
}) => {
  const {
    execute: generateEPSGraph,
    loading: epsLoading,
    response: epsGraphData,
  } = useFetchApi("/api/dynamic-graph");

  const {
    execute: generateIncomeGraph,
    loading: incomeLoading,
    response: incomeGraphData,
  } = useFetchApi("/api/dynamic-graph");

  const {
    execute: generateAssetLinEquGraph,
    loading: assetLinEqLoading,
    response: assetLinEquGraphData,
  } = useFetchApi("/api/dynamic-graph");

  const fetchAllGraphs = useCallback(() => {
    if (!selectedStock) return;

    const commonPayload = {
      selectedStocks: [selectedStock],
      filter: "annually",
      baseCurrency,
    };

    generateEPSGraph({
      ...commonPayload,
      selectedMetrics: [
        { name: "EPS Split Adjusted", sortableId: "1-Investor Ratio-4" },
      ],
      period: "5",
    });

    generateIncomeGraph({
      ...commonPayload,
      selectedMetrics: [
        { name: "revenues", sortableId: "7-Income Statement-1" },
        { name: "profit_before_tax", sortableId: "7-Income Statement-5" },
        { name: "net_profits", sortableId: "7-Income Statement-9" },
      ],
      period: "5",
    });

    generateAssetLinEquGraph({
      ...commonPayload,
      selectedMetrics: [
        { name: "total_assets", sortableId: "6-Balance Sheet-0" },
        { name: "total_liabilities", sortableId: "6-Balance Sheet-1" },
        { name: "total_equity", sortableId: "6-Balance Sheet-6" },
      ],
      period: "5",
    });
  }, [selectedStock, baseCurrency]);

  useEffect(() => {
    fetchAllGraphs();
  }, [selectedStock, baseCurrency]);

  return (
    <div>
      <Title level={5}>Annual History</Title>
      <div className="flex flex-col gap-6">
        <ChartCard
          title="EPS Split Adjusted"
          subtitle="Annual area trend"
          graphData={epsGraphData}
          loading={epsLoading}
          baseCurrency={baseCurrency}
          defaultChartType="area"
          defaultFilter="annually"
          showFilterToggle={false}
        />

        <ChartCard
          title="Income"
          subtitle="Annual area trend"
          graphData={incomeGraphData}
          loading={incomeLoading}
          baseCurrency={baseCurrency}
          defaultChartType="area"
          defaultFilter="annually"
          showFilterToggle={false}
        />

        <ChartCard
          title="Assets, Liabilities & Equity"
          subtitle="Annual area trend"
          graphData={assetLinEquGraphData}
          loading={assetLinEqLoading}
          baseCurrency={baseCurrency}
          defaultChartType="area"
          defaultFilter="annually"
          showFilterToggle={false}
        />
      </div>
    </div>
  );
};
